import React from "react";
import { useFieldArray, Controller } from "react-hook-form";
import {
  Form,
  Collapse,
  Input,
  Select,
  Switch,
  Space,
  Button,
  InputNumber,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
moment.tz.setDefault("Etc/UTC");

const JobParametersConfigurationElement = (props) => {
  const { control, errors, watch } = props;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "job.jobParameters",
  });

  const parameterType = (index) => {
    switch (watch(`job.jobParameters.${index}.type`)) {
      case "Date":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Date Calc"
              help={errors.job?.jobParameters?.[index]?.dateCalc?.message}
              required
              validateStatus={
                errors.job?.jobParameters?.[index]?.dateCalc ? "error" : ""
              }
            >
              <Controller
                control={control}
                name={`job.jobParameters.${index}.dateCalc`}
                render={({ field }) => (
                  <InputNumber
                    style={{ width: "180%" }}
                    {...field}
                    defaultValue={-1}
                    placeholder="Enter Date Calc value "
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Date In Utc">
              <Controller
                control={control}
                name={`job.jobParameters.${index}.dateInUtc`}
                render={({ field: { value, onChange } }) => (
                  <Switch
                    checked={value}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Date Format"
              help={errors.job?.jobParameters?.[index]?.dateFormat?.message}
              required
              validateStatus={
                errors.job?.jobParameters?.[index]?.dateFormat ? "error" : ""
              }
            >
              <Controller
                control={control}
                name={`job.jobParameters.${index}.dateFormat`}
                render={({ field }) => (
                  <Input
                    style={{ width: "180%" }}
                    placeholder="Enter Date Format value "
                    {...field}
                    defaultValue="yyyyMMdd"
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Use As Business Date">
              <Controller
                control={control}
                name={`job.jobParameters.${index}.useAsBusinessDate`}
                render={({ field: { value, onChange } }) => (
                  <Switch
                    checked={value}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "Fixed":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Value"
              help={errors.job?.jobParameters?.[index]?.fixedvalue?.message}
              required
              validateStatus={
                errors.job?.jobParameters?.[index]?.fixedvalue ? "error" : ""
              }
            >
              <Controller
                control={control}
                name={`job.jobParameters.${index}.fixedvalue`}
                render={({ field }) => (
                  <Input
                    {...field}
                    style={{ width: "180%" }}
                    placeholder="Enter Fixed value "
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "List":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Value"
              help={errors.job?.jobParameters?.[index]?.listvalue?.message}
              required
              validateStatus={
                errors.job?.jobParameters?.[index]?.listvalue ? "error" : ""
              }
            >
              <Controller
                control={control}
                name={`job.jobParameters.${index}.listvalue`}
                render={({ field }) => (
                  <TextArea
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Enter list "
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "Formatted":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Format Pattern"
              help={
                errors.job?.jobParameters?.[index]?.formatPatternString?.message
              }
              required
              validateStatus={
                errors.job?.jobParameters?.[index]?.formatPatternString
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.jobParameters.${index}.formatPatternString`}
                render={({ field }) => (
                  <Input
                    {...field}
                    style={{ width: "180%" }}
                    placeholder="Enter Format Pattern String"
                  />
                )}
              />
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["4"]} expandIconPosition="end">
          <Panel header="Job Parameters Configuration " key="4">
            <Form.Item
              {...formItemLayout}
              label="Job Parameters"
              help={errors?.job?.jobParameters?.message}
              required
              validateStatus={errors?.job?.jobParameters ? "error" : ""}
            >
              {fields?.map((item, index) => {
                return (
                  <>
                    <div>
                      <Space
                        key={item.id}
                        style={{
                          display: "Block",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          label="Parameter name              "
                          help={
                            errors.job?.jobParameters?.[index]?.name?.message
                          }
                          required
                          validateStatus={
                            errors.job?.jobParameters?.[index]?.name
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.jobParameters.${index}.name`}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Enter job Parameter Name"
                              />
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          label="Parameter types"
                          help={
                            errors.job?.jobParameters?.[index]?.type?.message
                          }
                          required
                          validateStatus={
                            errors.job?.jobParameters?.[index]?.type
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.jobParameters.${index}.type`}
                            render={({ field }) => (
                              <Select
                                showSearch
                                placeholder="Select job Parameter Type"
                                {...field}
                              >
                                <Option value="Date">Date</Option>
                                <Option value="Fixed">Fixed</Option>
                                <Option value="List">List</Option>
                                <Option value="Formatted">Formatted</Option>
                              </Select>
                            )}
                          />
                        </Form.Item>
                        {parameterType(index)}
                        <MinusCircleOutlined onClick={() => remove(index)} />
                      </Space>
                    </div>
                  </>
                );
              })}
              <Button
                block
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  append({
                    name: "",
                    type: "Date",
                    dateCalc: -1,
                    dateFormat: "yyyyMMdd",
                  })
                }
              >
                Add Job Parameters
              </Button>
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default JobParametersConfigurationElement;
